import Constants from '@/constants';

/** Map i18n / CMS language codes to a valid BCP 47 lang for html[lang]. */
export const toDocumentLang = (language: string): 'en' | 'es' =>
  language === Constants.LANGUAGE.SPANISH_LANGUAGE_CODE ? 'es' : 'en';

/**
 * Keep document.documentElement.lang aligned with app i18n so assistive tech and
 * browser translate heuristics match Pathway chrome (PATHWAY-3674 Layer A).
 */
export const syncDocumentLang = (language: string): void => {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.lang = toDocumentLang(language);
};
